import {GengineDataHolder, TWithPlayers} from './gengine-data-holder';
import {IGenginePlayer} from './i-gengine-player';

export class GengineWorld<TData extends TWithPlayers>
  extends GengineDataHolder <TData>
{
  constructor(player: IGenginePlayer, name: string) {
    super(name, 'world', player);
  }
}
